module.exports = __webpack_public_path__ + "assets/img/kv-eb06d1b7.jpg";